import Cookies from "js-cookie";

// the backend consumes this cookie and redirects
const REDIRECT_COOKIE_NAME = "ws_client_redirect";

const setRedirectCookie = (redirectLocation: string) => {
    Cookies.set(REDIRECT_COOKIE_NAME, redirectLocation, { secure: true });
};

export const redirectWithCurrentPage = (redirectLocation: string) => {
    // webapp2 "helpfully" modifies and adds the host to the location header
    // while aiohttp does not, so we have to check if it's a relative or absolute
    // url then use the current location to get the hostname correct
    const redirect = redirectLocation.startsWith("/")
        ? new URL(redirectLocation, new URL(window.location.href))
        : new URL(redirectLocation);

    const url = new URL(window.location.href);
    const redirectPath = url.pathname + url.search + url.hash;
    redirect.searchParams.set("redirect", redirectPath);
    setRedirectCookie(redirectPath); // sso will "forget" the redirect url

    window.location.href = redirect.href;
    return undefined as never; // shouldn't happen
};
